
import React, { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Button,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';
import { useAPI } from '../../../shared/services/api/API';
import { WASHUB_CONSTANTS } from '../../../shared/Constants';
import { ICategory, IProcess, IResponseProcessManagement } from '../model/ProcessManagement';
import { MaterialReactTable, MRT_ColumnDef } from 'material-react-table';
declare const qz: any;
export const WashingLoad = () => {
  const { httpGet, httpPost, handleAlertBar } = useAPI();
  const [form, setForm] = useState({
    category: '',
    program: '',
    machineId: '',
    businessStoreId: '',
    departmentId: '',
    operatorName: '',
    loadedKgs: '',
  });

  const [categoryList, setCategoryList] = useState<ICategory[]>([]);
  const [programList, setProgramList] = useState<IProcess[]>([]);
  const [machineList, setMachineList] = useState<ICategory[]>([]);
  const [businessStoreList, setBusinessStoreList] = useState<ICategory[]>([]);
  const [departmentList, setDepartmentList] = useState<IProcess[]>([]);
  const [laundryProcessOrderList, setLaundryProcessOrderList] = useState<IResponseProcessManagement[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const businessDropDownList = [
    { label: 'Select Business Store', field: 'businessStoreId', list: businessStoreList, keyField: 'id', nameField: 'name' },
    { label: 'Select Department', field: 'departmentId', list: departmentList, keyField: 'id', nameField: 'name' },
  ]
  const dropDownList = [
    { label: 'Select Machine', field: 'machineId', list: machineList, keyField: 'machineId', nameField: 'machineId' },
    { label: 'Select Category', field: 'category', list: categoryList, keyField: 'id', nameField: 'name' },
    { label: 'Select Program', field: 'program', list: programList, keyField: 'name', nameField: 'name' },
  ];
  const queryParams = {
    page: 0,
    size: 1000,
    sortColumn: 'modifiedAt',
    isDescending: true,
  };

  const fetchData = async () => {
    getMachines();
    getBusinessStores();
    fetchCategories();
    getPrograms();
    getAllLaundryProcessOrder();
  };

  const handleChange = (field: string, value: string) => {
    setForm(prev => ({ ...prev, [field]: value }));
    if (field === 'businessStoreId') fetchDepartments(value);
  };

  const fetchCategories = async () => {
    try {
      const res = await httpGet(WASHUB_CONSTANTS.API_URLS.CATEGORIES_DATA_GET, queryParams);
      if (res.status === 200) {
        setCategoryList(res.data);
      }
    } catch (err) {
      handleAlertBar('error', 'Failed to load categories');
    }
  };
  const getPrograms = async () => {
    try {
      const res = await httpPost(WASHUB_CONSTANTS.API_URLS.PROCESS_TYPE_DATA_GET, null);
      if (res.status === 200) {
        setProgramList(res.data);
      }
    } catch (err) {
      handleAlertBar('error', 'Failed to load programs');
    }
  };

  const getMachines = () =>
    httpPost(WASHUB_CONSTANTS.API_URLS.WASHING_MACHINE_DATA_GET, null)
      .then(res => res.status === 200 && setMachineList(res.data));

  const getBusinessStores = () =>
    httpGet(WASHUB_CONSTANTS.API_URLS.BUSINESS_STORE_ADMIN_BUSINESS_DATA_GET, queryParams)
      .then(res => {
        if (res.status === 200) {
          const sorted = [...res.data].sort((a, b) =>
            a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
          setBusinessStoreList(sorted);
        }
      });

  const fetchDepartments = (storeId: string) =>
    httpGet(`${WASHUB_CONSTANTS.API_URLS.BUSINESSSTORE_DEPARTMENT_DATA_GET}/${storeId}`, queryParams)
      .then(res => {
        if (res.status === 200) {
          const sorted = [...res.data].sort((a, b) =>
            a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
          setDepartmentList(sorted);
        }
      });

  const createLaundryProcessOrder = async () => {
    setIsLoading(true);
    const payload = {
      machineId: form.machineId,
      loadedKgs: +form.loadedKgs,
      businessStoreId: form.businessStoreId,
      departmentId: form.departmentId,
      categoryId: form.category,
      program: form.program,
      operatorName: form.operatorName
    };
    httpPost(WASHUB_CONSTANTS.API_URLS.CREATE_LAUNDRY_PROCESS_DATA_POST, payload).then(response => {
      setIsLoading(false);
      if (response.status === 200) {
        setForm({
          category: '',
          program: '',
          machineId: '',
          businessStoreId: '',
          departmentId: '',
          operatorName: '',
          loadedKgs: '',
        });
        handleAlertBar('success', 'Laundry Process Order Created Successfully');
      } else {
        handleAlertBar('error', response?.data?.message || 'Error occurred');
      }
    });
  };

  const printLabel = async (printerName: string, printerLabel: any) => {
    try {
      if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
      }
      let printer = "";
      //If printerName is null, it will use default printer
      if (!printerName) {
        printer = await qz.printers.getDefault();
      } else {
        printer = await qz.printers.find(printerName);
      }
      const config = qz.configs.create(printer);
      for (const label of printerLabel) {
        let data = [];
        if (printerName === "Epson") {
          data = [
            {
              type: "raw",
              format: "command",
              flavor: "base64",
              data: label,
            },
          ];
        } else {
          data = [label];
        }
        await qz.print(config, data);
      }
      handleAlertBar('success','Print laundry process order receipt successfully');
                      setForm({
                        category: '',
                        program: '',
                        machineId: '',
                        businessStoreId: '',
                        departmentId: '',
                        operatorName: '',
                        loadedKgs: '',
                      });
    } catch (error) {
      alert("Error: " + error);
    }
  };

  const createAndPrintLaundryProcessOrder = async (orderId?: string) => {
    setIsLoading(true);
    const payload: any = {
      machineId: form.machineId,
      loadedKgs: +form.loadedKgs,
      businessStoreId: form.businessStoreId,
      departmentId: form.departmentId,
      categoryId: form.category,
      program: form.program,
      operatorName: form.operatorName
    };
    if (orderId) {
        payload['orderId'] = orderId;
    }
    httpPost(WASHUB_CONSTANTS.API_URLS.CREATE_PRINT_LAUNDRY_PROCESS_DATA_POST, payload).then(response => {
      setIsLoading(false);
      if (response.status === 200) {
        try {
          if (response?.data?.label?.length > 0) {
            printLabel('', response?.data?.label);
          }
          if (response?.data?.epsonLabel?.length > 0) {
            printLabel('Epson',response?.data?.epsonLabel);
          }
        } catch (error: any) {
          throw new Error('Error fetching Print label: ', error);
        }
      } else {
        if (response.data.error) {
          console.error('Error fetching Print label: ', response.data.message);
        }
      }
    });
  };

  const getAllLaundryProcessOrder = async () => {
    try {
      const res = await httpPost(WASHUB_CONSTANTS.API_URLS.RECENT_LAUNTRY_PROCESS_DATA_POST, null);
      if (res.status === 200) {
        setLaundryProcessOrderList(res.data);
      }
    } catch (err) {
      handleAlertBar('error', 'Failed to load programs');
    }
  };

      const columns = useMemo<MRT_ColumnDef<IResponseProcessManagement>[]>(
        () => [
          {
            accessorKey: 'laundryProcessOrderId',
            header: 'OrderId',
            enableColumnOrdering: false,
            enableEditing: false, //disable editing on this column
            enableHiding: false,
            enableSorting: false,
            size: 50,
          },
          {
            accessorKey: 'orderDate',
            header: 'Date',
            enableEditing: false, //disable editing on this column
            enableHiding: false,
            enableSorting: false,
            size: 80,
          },
          {
            accessorKey: 'businessDepartment.deptCode',
            header: 'Dept Code',
            enableEditing: false,
            enableSorting: false,
            size: 100,
            grow: false,
          },
          {
            accessorKey: 'category.name',
            header: 'Category',
            enableEditing: false,
            enableHiding: false,
            enableSorting: false,
            size: 60,
          },
          {
            accessorKey: 'program',
            header: 'Program',
            enableEditing: false,
            enableHiding: false,
            enableSorting: false,
            size: 50,
          },
          {
            accessorKey: 'loadedKgs',
            header: 'LoadedKgs',
            enableEditing: false,
            enableHiding: false,
            enableSorting: false,
            size: 60,
          },
          {
            accessorKey: 'operatorName',
            header: 'Operator',
            enableEditing: false,
            enableHiding: false,
            enableSorting: false,
            enableGlobalFilterModes: false,
            size: 70,
          }
        ],
        [],
      );

  useEffect(() => {
    fetchData();
  }, []);

  const isAnyEmpty = (obj: any) => {
    return Object.values(obj).some(value => value === '' || value === null || value === undefined);
  }

  return (
    <div>
      <Grid container justifyContent="space-between">
        <Grid item className="mb-2 mt-1 ms-2">
          <Typography color="primary" variant="h5" textAlign="center">
            Washing Load
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={1} className="p-1">
          {businessDropDownList?.map(({ label, field, list, keyField, nameField }) => (
              <Grid item xs={12} sm={6} md={3} lg={3} key={field}>
                <TextField
                  fullWidth
                  select
                  size="small"
                  label={label}
                  required
                  value={form[field as keyof typeof form]}
                  onChange={e => handleChange(field, e.target.value)}
                >
                  {list.map((item: any) => (
                    <MenuItem key={item[keyField]} value={item[keyField]}>
                      {item[nameField]}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            ))}
      </Grid>
      <Grid container spacing={1} className="p-1 pe-2">
            {dropDownList?.map(({ label, field, list, keyField, nameField }) => (
              <Grid item xs={12} sm={6} md={3} lg={3} key={field}>
                <TextField
                  fullWidth
                  select
                  size="small"
                  required
                  label={label}
                  value={form[field as keyof typeof form]}
                  onChange={e => handleChange(field, e.target.value)}
                >
                  {list.map((item: any) => (
                    <MenuItem key={item[keyField]} value={item[keyField]}>
                      {item[nameField]}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            ))}

            <Grid item xs={12} sm={6} md={3} lg={3}>
              <TextField
                fullWidth
                size="small"
                label="Operator Name"
                required
                value={form.operatorName}
                onChange={e => handleChange('operatorName', e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3} lg={3}>
              <TextField
                fullWidth
                size="small"
                label="Loaded KGs"
                type="number"
                required
                value={form.loadedKgs}
                onChange={e => handleChange('loadedKgs', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} display="flex" justifyContent="end" container spacing={1}>
                <Grid item >
                <Button variant="contained" onClick={createLaundryProcessOrder} disabled={isAnyEmpty(form) || isLoading}>
                    {'Create Load'}
                </Button>
                </Grid>
                <Grid item >
                <Button variant="contained" onClick={() =>createAndPrintLaundryProcessOrder()} disabled={isAnyEmpty(form) || isLoading}>
                    {'Create & Print Load'}
                </Button>
                </Grid>
            </Grid>
      </Grid>
      <hr></hr>
            <div className="pe-2">
              <MaterialReactTable
                defaultColumn={{
                  maxSize: 150,
                  minSize: 10,
                  size: 50,
                }}
                displayColumnDefOptions={{
                  'mrt-row-actions': {
                    muiTableHeadCellProps: {
                      align: 'center',
                    },
                    size: 100,
                  },
                }}
                muiTablePaperProps={{
                  sx: {
                    width: '100%',
                    '& .css-1tbggly': {
                      minHeight: '2px',
                    },
                  },
                }}
                columns={columns}
                enableFullScreenToggle={false}
                enableStickyHeader
                positionActionsColumn="last"
                enableRowActions
                enableColumnActions={false}
                enableColumnFilters={false}
                enableFilters={true}
                enableSorting={false}
                enableHiding={false}
                enableDensityToggle={false}
                enableToolbarInternalActions={false}
                data={laundryProcessOrderList}
                state={{ isLoading: isLoading }}
                editDisplayMode="modal"
                muiTableContainerProps={{
                  sx: {
                    height: '42vh',
                  },
                }}
                renderRowActions={({ row, table }) => (
                  <Box sx={{ display: 'flex', justifyContent: 'center', gap: '0.5rem' }}>
                    <Button
                      className="ps-1 pe-1"
                      variant="contained"
                      sx={{ color: 'white' }}
                      onClick={() => createAndPrintLaundryProcessOrder(row?.original.laundryProcessOrderId)}
                    >
                      <Typography variant="labelNormal">Print Receipt</Typography>
                    </Button>
                  </Box>
                )}
              />
            </div>
    </div>
  );
};
